import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-header ml-5 mt-8" }
const _hoisted_2 = { class: "modal-body mx-4" }
const _hoisted_3 = {
  key: 0,
  class: "mx-5 my-3 h5 empty-alerts"
}
const _hoisted_4 = { class: "longtime-continuous-warning mb-2" }
const _hoisted_5 = { class: "mx-5 my-3 h5 longtime-continuous-warning-table" }
const _hoisted_6 = { class: "d-flex justify-content-end m-3 mt-4" }

import i18n from '@/lang/i18n';
import ModalFlashMessage from "@/components/Common/ModalFlashMessage.vue";
import PaginateWithCount from "@/components/PaginateWithCount.vue";
import { Ref, ref, computed, onMounted, watch } from "vue"
import { GDialog } from 'gitart-vue-dialog'
import { formatTimeFromSeconds, formatDateTimeJP, formatTime } from "@/services/functions"
import Api from "@/services/api/ApiServiceFabrick";


export default /*@__PURE__*/_defineComponent({
  __name: 'IgnoreLongTimelongContinuousWarningUpdateModal',
  props: {
    modelValue: { type: Boolean },
    deliveryPlanId: {},
    createAuthority: { type: Boolean },
    showFlash: { type: Function }
  },
  emits: ['update:modelValue', 'confirm', 'cancel'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const modelValue = computed(() => {
  return props.modelValue;
})

const currentPage:Ref<number> = ref(1)
const totalPage:Ref<number> = ref(0)

const longtimeContinuousWarnings = ref([])
onMounted(() => {
  getAlertStatuses()
})

watch(() => currentPage.value,
() => {
  getAlertStatuses()
})

function getAlertStatuses() {
  alertsLoading.value = true
  longtimeContinuousWarnings.value = []
  Api().getLongTimeContinuousAlerts({
    delivery_plan_id: props.deliveryPlanId,
    page: currentPage.value,
  }).then((res) => {
    currentPage.value = res.current_page
    totalPage.value = Math.ceil(res.total / res.per_page)
    longtimeContinuousWarnings.value = res.data
    alertsLoading.value = false
  })
}

const loading:Ref<boolean> = ref(false)
const alertsLoading:Ref<boolean> = ref(true)

function closeModal() {
  emits('cancel')
}

const viewTimes = computed(() => {
  let ret = [];
  longtimeContinuousWarnings.value.forEach((arr) => {
    const start = new Date(arr.start_time);
    const end = new Date(arr.end_time);
    const diffSeconds = (arr.time_range);
    const range = formatTimeFromSeconds(diffSeconds)
    ret.push({
      start: formatDateTimeJP(start),
      end: formatTime(end),
      range: range,
      diffSeconds: diffSeconds,
      is_extension: arr.is_extension
    })
  })
  return ret;
})

function ignoreAlert(index: number) {
  longtimeContinuousWarnings.value[index].is_extension = true
}

function requestChangeStatus(index: number) {
  loading.value = true
  Api().updateLongTimeContinuousAlerts(longtimeContinuousWarnings.value).then((data) => {
    loading.value = false
    props.showFlash(i18n.global.t('pages.common.messages.successUpdate'), true, "info", true)
    closeModal()
  }).catch(() => {
    loading.value = false
    flashMessage.value = {
      message: i18n.global.t('pages.common.messages.failedUpdate'),
      show: true,
      type: "error",
      cancel: false
    }
  })
}

const flashMessage = ref({
  message:"",
  show: false,
  type: "info",
  cancel: true
})


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_unref(GDialog), {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modelValue).value = $event)),
    "max-width": "50%",
    transition: "custom-from-bottom-transition",
    persistent: true
  }, {
    default: _withCtx(() => [
      _createVNode(ModalFlashMessage, {
        message: flashMessage.value.message,
        show: flashMessage.value.show,
        type: flashMessage.value.type,
        cancel: flashMessage.value.cancel,
        onSetShow: _cache[0] || (_cache[0] = (show) => {flashMessage.value.show = show})
      }, null, 8, ["message", "show", "type", "cancel"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", {
          class: _normalizeClass([props.titleClass, "h4 m-0"])
        }, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.ignoreLongtimeContinuousWarning.updateModalTitle')), 3)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "supplementary-item"),
        _createElementVNode("div", {
          class: _normalizeClass(props.noteClass)
        }, [
          (!alertsLoading.value && viewTimes.value.length == 0)
            ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.ignoreLongtimeContinuousWarning.emptyAlerts')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("table", _hoisted_5, [
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(viewTimes.value, (warning, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: 'warning'+index
                  }, [
                    _createElementVNode("td", null, _toDisplayString(warning.start) + " ~ " + _toDisplayString(warning.end) + " (" + _toDisplayString(warning.range) + ")", 1),
                    _createElementVNode("td", null, [
                      (warning.is_extension)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            disabled: true
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.dailyReports.ignoreLongtimeContinuousWarning.ignoredBtn')), 1)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            onClick: ($event: any) => (ignoreAlert(index))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.dailyReports.ignoreLongtimeContinuousWarning.ignoreBtn')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createVNode(PaginateWithCount, {
            class: "justify-end",
            totalPage: totalPage.value,
            modelValue: currentPage.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentPage).value = $event)),
            showItemCount: false
          }, null, 8, ["totalPage", "modelValue"])
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_v_btn, {
          class: "ma-2 reset-btn",
          onClick: closeModal
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.backBtn')), 1)
          ]),
          _: 1
        }),
        (viewTimes.value.length != 0 && props.createAuthority)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              class: _normalizeClass(["ma-2 exec-btn", props.confirmBtnClass]),
              onClick: requestChangeStatus,
              loading: loading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.saveBtn')), 1)
              ]),
              _: 1
            }, 8, ["class", "loading"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }, 8, ["modelValue"]))
}
}

})